export let cont = 0

const bigVideo = (id: string): void => {
    const videoBoxes: NodeListOf<HTMLDivElement> = document.querySelectorAll('.videoBox')

    videoBoxes.forEach((videoBox: HTMLDivElement) => {
        if (id === videoBox.id) {
            videoBox.classList.remove('less')
            videoBox.classList.add('big')
        } else {
            videoBox.classList.remove('big')
            videoBox.classList.add('less')
        }
    })
}

const lessVideo = (): void => {
    const videoBoxes: NodeListOf<HTMLDivElement> = document.querySelectorAll('.videoBox')

    videoBoxes.forEach((videoBox) => {
        videoBox.classList.remove('big')
        videoBox.classList.remove('less')
    })
}

export const createVideoBoxElement = (id: string, isPublisher: boolean) => {
    const videoBox = document.getElementById(id)

    if (!videoBox) return

    const btnFullBox = document.createElement('button')
    const btnLessBox = document.createElement('button')
    const svgFull = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    const svgLess = document.createElementNS('http://www.w3.org/2000/svg', 'svg')

    videoBox.classList.add('videoBox')
    videoBox.tabIndex = cont+1
    if (isPublisher) videoBox.id = id + ' publisher'

    btnFullBox.classList.add('fullBtn')
    btnLessBox.classList.add('lessBtn')

    svgFull.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
    svgFull.setAttribute('viewBox', '0 0 448 512')
    svgLess.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
    svgLess.setAttribute('viewBox', '0 0 448 512')
    svgFull.innerHTML = `<path d="M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"/>`
    svgLess.innerHTML = `<path d="M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"/>`

    btnFullBox.appendChild(svgFull)
    btnLessBox.appendChild(svgLess)

    btnFullBox.addEventListener('click', () => bigVideo(videoBox.id))
    btnLessBox.addEventListener('click', () => lessVideo())

    videoBox.appendChild(btnFullBox)
    videoBox.appendChild(btnLessBox)

    cont++
}